export const goToUrl = (url: string) => {
  window.location.href = url;
};
export default goToUrl;
